<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Entry Pass</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">

    <div class="form-group">
      <label for="entryPassSelect">Entry Pass Type</label>
      <select id="entryPassSelect" class="custom-select" name="entryPass"
              [(ngModel)]="entryPass.entry_pass_id" required
              [disabled]="loadingEntryPasses" [class.disabled]="loadingEntryPasses">
        <option *ngIf="loadingEntryPasses">Loading...</option>
        <option *ngIf="!loadingEntryPasses" [ngValue]="null">---</option>
        <option *ngFor="let entryPassType of entryPassList" [ngValue]="entryPassType.id">
          {{ entryPassType.name }}
          <ng-container *ngIf="entryPassType.status === EntryPassStatus.retired">(Retired)</ng-container>
          <ng-container *ngIf="entryPassType.status === EntryPassStatus.draft">(Draft)</ng-container>
        </option>
      </select>
      <div class="form-text text-danger">
        {{ errors.entry_pass_id }}
      </div>
    </div>

    <div class="form-group">
      <label for="numberOfUsesTotalInput">Total Number of Uses</label>
      <input id="numberOfUsesTotalInput" type="number" min="0" step="1"
             class="form-control" name="numberOfUsesTotal" required
             [(ngModel)]="entryPass.number_of_uses_total">
      <small class="form-text">
        The number of uses which the entry pass has in total. This is only used to display to the customer, and does not affect the functionality of the pass.
      </small>
      <div class="form-text text-danger">
        {{ errors.number_of_uses_total }}
      </div>
    </div>

    <div class="form-group">
      <label for="numberOfUsesRemainingInput">Number of Uses Remaining</label>
      <input id="numberOfUsesRemainingInput" type="number" min="0" step="1"
             class="form-control" name="numberOfUsesRemaining" required
             [(ngModel)]="entryPass.number_of_uses_remaining">
      <div class="form-text text-danger">
        {{ errors.number_of_uses_remaining }}
      </div>
    </div>

    <div class="form-group">
      <label for="expirationDateInput">Expiry Date (optional)</label>
      <app-date-picker [id]="'expirationDateInput'"
                       [(content)]="entryPass.expiration_date"></app-date-picker>
      <div class="form-text text-danger">
        {{ errors.expiration_date }}
      </div>
    </div>

    <div class="form-group" *ngIf="association">
      <label for="ownerSelect">Owner</label>
      <select id="ownerSelect" class="custom-select" name="customerId"
              [(ngModel)]="customerId" required
              [disabled]="loadingAssociationManagers" [class.disabled]="loadingAssociationManagers">
        <option *ngIf="loadingAssociationManagers">Loading...</option>
        <option *ngIf="!loadingAssociationManagers" [ngValue]="null">---</option>
        <option *ngFor="let associationManager of associationManagerList" [ngValue]="associationManager.customer_id">
          {{ associationManager.customer_first_name }} {{ associationManager.customer_last_name }}
        </option>
      </select>
      <small class="form-text">
        Select an association manager to act as the owner of the association's entry pass.
      </small>
      <div class="form-text text-danger">
        {{ errors.customerId }}
      </div>
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!(loadingEntryPasses || loadingSubmit)"
            (click)="handleSave()">
      Save
    </button>
    <button type="button" class="btn btn-primary disabled" disabled
            *ngIf="loadingEntryPasses || loadingSubmit">
      Loading...
    </button>
  </div>

</ng-container>
